/** Store/filter URL value (YYYY-MM-DD). */
export const toFilterDateValue = (iso?: string): string => {
    if (!iso) return '';
    return iso.slice(0, 10);
};

export const toDisplayDate = (value: string): string => {
    if (!value) return '';
    const [year, month, day] = value.split('-');
    if (!year || !month || !day) return value;
    return `${month}/${day}/${year}`;
};

export const toApiStartDateTimeGte = (date: string): string | undefined => {
    if (!date) return undefined;
    return `${date}T00:00:00`;
};

export const toApiStartDateTimeLte = (date: string): string | undefined => {
    if (!date) return undefined;
    return `${date}T23:59:59`;
};
